import SiteUrlStorage from "utilities/SiteUrlStorage";
import TransactionSubmitter from "models/TransactionSubmitter";
import TransactionStorage from "utilities/TransactionStorage";

export default async function sendOfflinePostRequests() {
	console.log('[SYNC] SENDING OFFLINE POST REQUESTS');
	await SiteUrlStorage.retrieve();
	return TransactionSubmitter.submit((successfulTransaction)=>{
			console.log('should delete it here?');
			TransactionStorage.removeItem(successfulTransaction.submit_id)
		})
		.then((promiseResults) => {
			return promiseResults;
		});
}